export type KeyCode = 'KeyW' | 'KeyA' | 'KeyS' | 'KeyD';
export type ControlScheme = 'wasd' | 'arrows';

const ARROW_TO_KEY: Record<string, KeyCode> = {
  ArrowUp: 'KeyW',
  ArrowLeft: 'KeyA',
  ArrowDown: 'KeyS',
  ArrowRight: 'KeyD',
};

export class InputHandler {
  private keys: Record<KeyCode, boolean> = {
    KeyW: false,
    KeyA: false,
    KeyS: false,
    KeyD: false
  };

  public lastKeyPressed?: KeyCode;
  public activeScheme: ControlScheme = 'wasd';

  constructor() {
    this.setupEventListeners();
  }

  private setupEventListeners() {
    window.addEventListener('keydown', (event) => {
      if (this.keys.hasOwnProperty(event.code)) {
        this.keys[event.code as KeyCode] = true;
        this.lastKeyPressed = event.code as KeyCode;
        this.activeScheme = 'wasd';
      } else if (ARROW_TO_KEY[event.code]) {
        const mapped = ARROW_TO_KEY[event.code];
        this.keys[mapped] = true;
        this.lastKeyPressed = mapped;
        this.activeScheme = 'arrows';
      }
    });

    window.addEventListener('keyup', (event) => {
      if (this.keys.hasOwnProperty(event.code)) {
        this.keys[event.code as KeyCode] = false;
      } else if (ARROW_TO_KEY[event.code]) {
        this.keys[ARROW_TO_KEY[event.code]] = false;
      }
    });
  }

  public isKeyPressed(key: KeyCode): boolean {
    return this.keys[key];
  }

  public isAnyKeyPressed(): boolean {
    return Object.values(this.keys).some(pressed => pressed);
  }

  public pressKey(key: KeyCode) {
    this.keys[key] = true;
    this.lastKeyPressed = key;
  }

  public releaseKey(key: KeyCode) {
    this.keys[key] = false;
  }

  public getKeys(): Record<KeyCode, boolean> {
    return { ...this.keys };
  }
}